import * as STATES from './states.constants';
import { State } from '../../models';

/** LOAD */
export function loadStates() {
    return { type: STATES.STATES_LOAD };
}

export function loadStatesSuccess(data: State[]) {
    return { type: STATES.STATES_LOAD_SUCCESS, payload: data };
}

export function loadStatesError(error: any) {
    return { type: STATES.STATES_LOAD_ERROR, payload: error };
}


/** ADD */
export function addStates(targetStates: State[]) {
    return { type: STATES.STATES_ADD, payload: targetStates };
}

export function addStatesSuccess(targetStates: State[]) {
    return { type: STATES.STATES_ADD_SUCCESS, payload: targetStates };
}

export function addStatesError(error: any) {
    return { type: STATES.STATES_ADD_ERROR, payload: error };
}


/** UPDATE */
export function updateState(targetState: State) {
    return { type: STATES.STATE_UPDATE, payload: targetState };
}

export function updateStateSuccess(targetState: State) {
    return { type: STATES.STATE_UPDATE_SUCCESS, payload: targetState };
}

export function updateStates(targetStates: State[]) {
    return { type: STATES.STATES_UPDATE, payload: targetStates };
}

export function updateStatesSuccess(targetStates: State[]) {
    return { type: STATES.STATES_UPDATE_SUCCESS, payload: targetStates };
}

export function updateStatesError(error: any) {
    return { type: STATES.STATES_UPDATE_ERROR, payload: error };
}


/** DELETE */
export function deleteState(guid: string) {
    return { type: STATES.STATE_DELETE, payload: guid };
}
export function deleteStateSuccess(guid: string) {
    return { type: STATES.STATE_DELETE_SUCCESS, payload: guid };
}

export function deleteStates(guids: string[]) {
    return { type: STATES.STATES_DELETE, payload: guids };
}

export function deleteStatesSuccess(States: State[]) {
    return { type: STATES.STATES_DELETE_SUCCESS, payload: States };
}

export function deleteStatesError(error: any) {
    return { type: STATES.STATES_DELETE_ERROR, payload: error };
}